import React from 'react'
import styles from './index.scss'

const SuccessModal = () => (
  <div className={styles['r-partner-add-success']}>
    <section className={styles['r-partner-add-success__wrapper']}>
      <header className="head">
        <div className="head-icon" />
        <p className="head-text">提交成功</p>
      </header>
      <div className="content">
        <p className="text">稍后会有专属顾问联系您，</p>
        <p className="text">因报名人数较多，请您耐心等待。</p>
      </div>
      <a className="return" href="https://www.renrenche.com">返回首页</a>
    </section>
  </div>
)
export default SuccessModal
